import type { Router } from 'vue-router'
import { useUserStore } from './store'

export default (router: Router) => {
  router.addRoute({
    path: '/login',
    name: 'login',
    component: () => import('@/modules/auth/views/TheLogin.vue'),
    meta: {
      layout: 'LoginSplitLayout',
      requiresAuth: false,
    },
  })
  router.addRoute({
    path: '/logout',
    name: 'logout',
    component: () => import('@/modules/auth/views/TheLogout.vue'),
    async beforeEnter() {
      await useUserStore().logoutUserWithToken()
    },
    meta: {
      layout: 'LoginLayout',
      requiresAuth: false,
    },
  })
}
